import React from 'react'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { Button } from '@/components/buttons/Button'

/**
 * @import import ConfirmModal from '@/components/layout/modals/ConfirmModal'
 * @param {object} props
 * @param {boolean} props.show Whether the dialog is open
 * @param {Function} props.onClose Called by Cancel and the header X
 * @param {node} props.title Heading in the dialog header
 * @param {node} props.children Dialog body
 * @param {node} props.confirmLabel Confirm button label
 * @param {node} [props.busyLabel] Confirm button label while busy
 * @param {boolean} [props.busy] Disables the confirm button and shows busyLabel
 * @param {boolean} [props.destructive] Renders the confirm button as the solid-red destructive CTA
 * @param {boolean} [props.confirmDisabled] Disables the confirm button without the busy label
 * @param {Function} props.onConfirm Called by the confirm button
 * @param {string} props.testIdPrefix Scopes the button test ids to `${testIdPrefix}-cancel` / `-confirm`
 */
const ConfirmModal = ({
  show,
  onClose,
  title,
  children,
  confirmLabel,
  busyLabel,
  busy = false,
  destructive = false,
  confirmDisabled = false,
  onConfirm,
  testIdPrefix,
}) => (
  <BasicModal
    show={show}
    onClose={onClose}
    title={title}
    size="small"
    // BasicModal's footer bar already lays the buttons out; a wrapper doubles its spacing.
    footer={
      <>
        <Button onClick={onClose} data-testid={`${testIdPrefix}-cancel`}>
          Cancel
        </Button>
        <Button
          brand={!destructive}
          destructive={destructive}
          onClick={onConfirm}
          disabled={busy || confirmDisabled}
          data-testid={`${testIdPrefix}-confirm`}
        >
          {busy ? busyLabel : confirmLabel}
        </Button>
      </>
    }
  >
    {children}
  </BasicModal>
)

export default ConfirmModal
